export default __webpack_public_path__ + "static/media/coach_guideme_softclix_lancingkit_lancets200_strips250_white@3x.a4b0e788.jpg";